<template>
  <div class="recycle-advantage-component">
    <div class="recycle-advantage-content box">
      <div>
        <img class="icon-advantage-title" src="./img/icon_advantage_title.png" />
      </div>
      <div class="advantage-swiper-content">
        <div class="advantage-swiper">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="advantage-swipe"
            :class="{
              active: item.id === select.id
            }"
          >
            <img class="icon-advantage" :src="item.icon" />
          </div>
        </div>
        <div class="advantage-swiper-indicator">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="indicator-item"
            :class="{
              over: item.id === overId
            }"
            @mouseover="pauseLoop(item)"
            @mouseout="restartLoop(item)"
            @click="changeSwipe(item)"
          >
            <img
              :src="item.id === select.id ? item.tabSelIcon : item.tabIcon"
              class="icon-indicator"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let timer = null;

export default {
  data () {
    return {
      num: 0,
      overId: '',
      list: [
        {
          id: '1',
          index: 0,
          icon: require('./img/icon_swipe_01.png'),
          tabIcon: require('./img/icon_swiper_ysaq_tab.png'),
          tabSelIcon: require('./img/icon_swiper_ysaq_tab_sel.png')
        },
        {
          id: '2',
          index: 1,
          icon: require('./img/icon_swipe_02.png'),
          tabIcon: require('./img/icon_swiper_jgtm_tab.png'),
          tabSelIcon: require('./img/icon_swiper_jgtm_tab_sel.png')
        },
        {
          id: '3',
          index: 2,
          icon: require('./img/icon_swipe_03.png'),
          tabIcon: require('./img/icon_swiper_znjc_tab.png'),
          tabSelIcon: require('./img/icon_swiper_znjc_tab_sel.png')
        },
        {
          id: '4',
          index: 3,
          icon: require('./img/icon_swipe_04.png'),
          tabIcon: require('./img/icon_swiper_hbbx_tab.png'),
          tabSelIcon: require('./img/icon_swiper_hbbx_tab_sel.png')
        }
      ],
      select: {}
    };
  },
  methods: {
    startLoop () {
      this.overLoop();
      timer = setInterval(() => {
        this.select = this.list[this.num % this.list.length];
        this.num++;
      }, 2500);
    },
    pauseLoop (item) {
      this.overLoop();
      this.overId = item.id;
      if (this.select.id !== item.id) {
        this.select = item;
      }
    },
    restartLoop (item) {
      this.overId = '';
      this.num = item.index + 1;
      this.startLoop();
    },
    overLoop () {
      clearInterval(timer);
    },
    changeSwipe (item) {
      if (item.id === this.select.id) return;
      this.select = item;
    }
  },
  destroyed () {
    this.overLoop();
  },
  mounted () {
    this.num++;
    this.select = this.list[0];
    this.startLoop();
  }
};
</script>

<style scoped>
.recycle-advantage-component {
  padding: 100px 0;
  height: 924px;
  background: linear-gradient(181deg,#fff084 2%, #fff9d0 50%, #fffef5 100%);
  border-radius: 0 260px 0 0;
  .recycle-advantage-content {
    text-align: center;
    .icon-advantage-title {
      width: 330px;
      height: 64px;
    }
  }
  .advantage-swiper-content {
    position: relative;
    margin-top: 60px;
    .advantage-swiper {
      width: 1200px;
      height: 600px;
    }
    .advantage-swipe {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      transition: 0.5s;
      &.active {
        opacity: 1;
      }
      .icon-advantage {
        width: 100%;
        height: 100%;
      }
    }
    .advantage-swiper-indicator {
      position: absolute;
      left: 0;
      bottom: 30px;
      display: flex;
      justify-content: center;
      width: 100%;
      .indicator-item {
        margin: 0 16px;
        cursor: pointer;
        width: 240px;
        height: 60px;
        transition: 0.3s;
        &.over {
          transform: scale(1.05);
        }
      }
      .icon-indicator {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.box {
  margin: 0 auto;
  width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/recycle-advantage.vue